/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { EquipmentTemplateServiceProvider } from './service/EquipmentTemplateServiceProvider';
import { EquipmentServiceProvider } from './service/EquipmentServiceProvider';
import { EquipmentAttachmentServiceProvider } from "./service/EquipmentAttachmentServiceProvider";


// Components
import { equipmentTemplateListComponent } from './component/EquipmentTemplateList';
import { equipmentTemplateViewComponent } from './component/EquipmentTemplateView';
import { equipmentListComponent } from './component/EquipmentList';
import { equipmentViewComponent } from './component/EquipmentView';

angular.module('serfimtic.gmao.equipment', ['ui.router', 'ngResource'])
.provider('equipmentTemplateService', EquipmentTemplateServiceProvider)
.provider('equipmentService', EquipmentServiceProvider)
.provider('equipmentAttachmentService', EquipmentAttachmentServiceProvider)
.component('equipmentTemplateList', equipmentTemplateListComponent)
.component('equipmentTemplateView', equipmentTemplateViewComponent)
.component('equipmentList', equipmentListComponent)
.component('equipmentView', equipmentViewComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractUrlState('gmao.equipment', '/equipment', ['ADMIN', 'EQUIPMENT_READ']))
        .state(State.componentState('gmao.equipment.list', 'equipmentList', '/list', 'ui.equipment.list'))
        .state(State.componentState('gmao.equipment.create', 'equipmentView', '/create',
            'ui.equipment.creation', undefined, ['ADMIN', 'EQUIPMENT_WRITE']))
        .state(State.componentState('gmao.equipment.update', 'equipmentView', '/update/:id',
            'ui.equipment.update', undefined, ['ADMIN', 'EQUIPMENT_READ']))

        .state(State.abstractUrlState('gmao.equipment.template', '/template', ['ADMIN']))
        .state(State.componentState('gmao.equipment.template.list', 'equipmentTemplateList', '/list',
            'ui.equipmenttemplate.list'))
        .state(State.componentState('gmao.equipment.template.create', 'equipmentTemplateView', '/create',
            'ui.equipmenttemplate.creation'))
        .state(State.componentState('gmao.equipment.template.update', 'equipmentTemplateView', '/update/:id',
            'ui.equipmenttemplate.update'));
})
.config(equipmentTemplateServiceProvider => {
    /** @ngInject */
    equipmentTemplateServiceProvider.setResourceUrl(Configuration.EQUIPMENT_TEMPLATE_PATH);
})
.config(equipmentServiceProvider => {
    /** @ngInject */
    equipmentServiceProvider.setResourceUrl(Configuration.EQUIPMENT_PATH);
})
.config(equipmentAttachmentServiceProvider => {
    /** @ngInject */
    equipmentAttachmentServiceProvider.setResourceUrl(Configuration.EQUIPMENT_ATTACHMENT_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/equipment/EquipmentModule.js